import { Place } from "@mui/icons-material";
import { Dialog } from "@mui/material";
import React from "react";
import SimpleWidgetsHeader from "../../../../components/SimpleWidgetsHeader/SimpleWidgetsHeader";
import NewAddress from "./NewAddress";
import { useStyles } from "./styles";

export default function NewAddressDialog({
    open,
    onClose,
    customerName,
    onCreated,
}) {
    const classes = useStyles();

    const handleClose = () => onClose?.();

    return (
        <Dialog open={!!open} onClose={handleClose} fullWidth maxWidth="sm">
            <div className={classes.DialogWrapper}>
                <SimpleWidgetsHeader
                    title="New Address / Phone"
                    Icon={Place}
                    onClose={handleClose}
                />
                <NewAddress
                    customerName={customerName}
                    onClose={handleClose}
                    onCreate={(addressDoc) => {
                        onCreated?.(addressDoc);
                    }}
                />
            </div>
        </Dialog>
    );
}


